// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_LI3","cls2":"LoswpTabsHero-cls2_q37 LoswpTabsHero-cls1_LI3","chrome-v2":"LoswpTabsHero-chrome-v2_F4C"};